import { compose } from 'recompose'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import {
  selectContactEmail,
  selectContactFirstName,
} from '../../../../../../store/selectors/contact'

const PrequalContactEmailLinkContainer = compose(
  connect(
    state => ({
      name: selectContactFirstName(state),
      email: selectContactEmail(state),
    }),
    dispatch => ({})
  ),
  injectIntl
)

export default PrequalContactEmailLinkContainer
